import angular from 'angular';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import moment from 'moment';

angular
  .module('cloudX')
  .controller('AddTaskScheduleDialogCtrl', [
    '$http',
    '$q',
    'flySvc',
    '$element',
    'appUrls',
    'close',
    'streamId',
    'relationId',
    'relType',
    'existingSchedules',
    'invoiceStreams',
    'dialogsSvc',
    'translateListFilter',
    '$timeout',
    'dataCache',
    'enumCacheSvc',
    '$translate',
    addTaskScheduleDialogCtrl,
  ]);

function addTaskScheduleDialogCtrl(
  $http,
  $q,
  flySvc,
  $element,
  appUrls,
  close,
  streamId,
  relationId,
  relType,
  existingSchedules,
  invoiceStreams,
  dialogsSvc,
  translateListFilter,
  $timeout,
  dataCache,
  enumCacheSvc,
  $translate,
) {
  var vm = this;
  vm.templates = [];
  vm.invoiceStreams = invoiceStreams;
  vm.showValidation = false;
  vm.deviations = [];
  vm.deviationsCollapsed = true;
  vm.mainTaskDeviation = null;

  dataCache.ready().then(function() {
    const users = dataCache.getArray('user');

    vm.users = users
      .filter(x => x.isActive || !x.hidden)
      .map(function(user) {
        return {
          id: user.userID,
          label: `${user.firstName} ${user.lastName}`,
          isActive: user.isActive,
        };
      })
      .sortByProperty('name');
    enumCacheSvc.get('employeeprofile').then(function(data) {
      vm.profiles = data.map(({ key, value }) => ({
        id: key,
        value,
        label: translateListFilter(key, 'employeeprofile', value),
      }));
    });
  });

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters, null, error.data.type);
    return '';
  };

  vm.schedule = {
    invoiceStreamId: streamId,
    relationId: relationId,
    type: 1,
    template: null,
    periodicity: null,
    planningStart: new Date(),
    planningStop: null,
    scheduleDate: null,
  };

  $http
    .get(`${appUrls.tasks}/Api/TaskTemplates/Schedules?relationType=${relType}`)
    .then(function({ data }) {
      vm.templates = data
        .filter(
          x =>
            (relType === 0 && x.appliesToCompany) ||
            (relType === 1 && x.appliesToSoleProprietor) ||
            (relType === 2 && x.appliesToPerson),
        )
        .map(x => ({
          ...x,
          label: translateListFilter(x.id, 'tasktemplate', x.name),
          periodicities: (x.periodicities || [])
            .map(p => ({
              ...p,
              label: translateListFilter(p.id, 'taskperiodicity', p.name),
            }))
            .sort(dynamicSort('label')),
        }))
        .sort(dynamicSort('label'));
    }, showError);

  function translateProfiles() {
    vm.profiles.forEach(p => {
      p.label = translateListFilter(p.id, 'employeeprofile', p.value);
    });
  }
  enumCacheSvc.get('employeeprofile').then(function(data) {
    vm.profiles = data.map(({ key, value }) => ({ id: key, value, label: value }));
    translateProfiles();
  });
  vm.getProfileLabel = function(profile) {
    if (!profile) return null;
    const prof = vm.profiles.find(p => p.id === profile);
    vm.showWarning = false;
    return prof ? prof.label : '/';
  };
  vm.translateTemplateAssignedType = deviation => {
    if (!deviation.templateAssignedType)
      return deviation.isMainTaskDeviation
        ? $translate.instant('Unassigned').toLowerCase()
        : $translate.instant('Use assigned user of main task').toLowerCase();
    if (deviation.templateAssignedType === 1)
      return vm.getProfileLabel(deviation.templateAssignedProfile).toLowerCase();
    if (deviation.templateAssignedType === 2)
      return vm.getUserName(deviation.templateAssignedUserId);
    return $translate.instant('Unassigned').toLowerCase();
  };

  vm.getUserName = function(userId) {
    if (!userId) return null;
    const user = vm.users.find(u => u.id === userId);
    return user ? user.label : '/';
  };

  vm.executionDurationChanged = function(deviation) {};

  vm.templateChanged = function() {
    vm.deviations = [];

    if (!vm.schedule.template || !vm.schedule.template.periodicities) {
      vm.schedule.periodicity = null;
      return;
    }
    if (vm.schedule.template.periodicities.length > 0) {
      vm.schedule.periodicity = vm.schedule.template.periodicities[0];
    }

    if (vm.schedule.template) {
      $http
        .get(`${appUrls.tasks}/api/TaskSchedules/deviationpossibilities/${vm.schedule.template.id}`)
        .then(
          function({ data }) {
            $timeout(function() {
              vm.deviations = data.sort(dynamicSort('-isMainTaskDeviation'));
              vm.mainTaskDeviation = data.find(x => x.isMainTaskDeviation);
            }, 500);
          },
          function(error) {
            showError(error);
          },
        );
    }
  };

  vm.saving = false;

  vm.assignedToChanged = function(deviation) {
    deviation.assignedType = deviation.assignedTo.assignedType;
    deviation.assignedUserId = deviation.assignedTo.userId;
    deviation.assignedProfile = deviation.assignedTo.profile;
  };

  var addSchedule = function(schedule) {
    return;
  };

  vm.scheduleExists = function() {
    if (
      !vm.schedule ||
      !vm.schedule.periodicity ||
      !vm.schedule.template ||
      !vm.schedule.invoiceStreamId
    )
      return false;
    if (vm.schedule.periodicity.showScheduleDate) return false;
    if (!existingSchedules) return false;
    return existingSchedules.some(function(schedule) {
      return (
        schedule.periodicity.id === vm.schedule.periodicity.id &&
        schedule.template.id === vm.schedule.template.id &&
        schedule.invoiceStreamId === vm.schedule.invoiceStreamId
      );
    });
  };
  vm.validate = function() {
    return !vm.scheduleExists();
  };
  vm.save = function() {
    if (vm.saving) return;
    vm.saving = true;
    var model = angular.copy(vm.schedule);
    model = {
      ...model,
      deviations: vm.deviations,
    };

    if (model.planningStart instanceof Date) model.planningStart = model.planningStart.ISO();
    if (model.planningStop && model.planningStop instanceof Date)
      model.planningStop = model.planningStop.ISO();

    if (model.scheduleDate && model.scheduleDate instanceof Date)
      model.scheduleDate = model.scheduleDate.ISO();

    $http.post(appUrls.tasks + '/Api/TaskSchedules/', model).then(
      function(response) {
        if (response && response.data) {
          $element.modal('hide');
          close([response.data], 500);
        }
        vm.saving = false;
      },
      function(error) {
        showError(error);
        vm.saving = false;
      },
    );
  };
  vm.cancel = function() {
    close(null, 500);
  };
  vm.dayMonthOptions = {
    minMode: 'day',
    maxMode: 'month',
    showWeeks: false,
    formatDayTitle: 'MMMM',
    datepickerMode: 'month',
    formatMonthTitle: ' ',
    initDate: new Date(2000, 11, 31),
    // minDate: new Date(2000, 0, 1),
    // maxDate: new Date(2000, 11, 31),
  };
}
